import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

// Define initial data points
let categories = [];
let initialized = false;

// Extend CategoryStore with EventEmitter to add eventing capabilities
class CategoryStore extends FluxStore
{
	getIsInitialized()
	{
		return initialized;
	}

	getCategories()
	{
		return categories;
	}
}

const categoryStore = new CategoryStore();

categoryStore.dispatchToken = AppDispatcher.register((action) => {
	let index = -1;
	switch (action.actionType) {
		case AppConstants.CATEGORY_RECEIVE_DATA:
			initialized = true;
			categories = action.categories;
			break;

		case AppConstants.CATEGORY_SAVE_SUCCESS:
			index = categories.map(t => t.id).indexOf(action.category.id);
			if (index !== -1)
			{
				categories[index] = action.category;
			}
			else
			{
				index = categories.length;
				categories.push(action.category);
			}
			break;

		case AppConstants.CATEGORY_DELETE_SUCCESS:
			index = categories.map(t => t.id).indexOf(action.categoryId);
			if (index !== -1)
			{
				categories.splice(index, 1);
			}
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	categoryStore.emitChange();
	return true;
});

export default categoryStore;



// WEBPACK FOOTER //
// ./Components/stores/CategoryStore.jsx